import { IApplicationState } from '../../types/redux';

export const selectDuplicateOfferLink = (state: IApplicationState): string | undefined => state.duplicateOfferLink;
